export class Scrolling {
    static lastScrollTop = 0;

    static addBodyNoScroll() {
        const body = document.querySelector('body');

        if(body) {
            const scrollTop = window.scrollY;
            body.classList.add('body--no-scroll-new');
            body.style.top = -scrollTop + 'px';
            Scrolling.lastScrollTop = scrollTop;
        }
    }

    static removeBodyNoScroll() {
        const body = document.querySelector('body');

        if(body) {
            body.classList.remove('body--no-scroll-new');
            body.style.top = '';

            
            const html = document.querySelector('html');

            if(html) {
                html.style.scrollBehavior = 'auto';
                window.scrollTo(0, Scrolling.lastScrollTop);
                html.style.scrollBehavior = 'smooth';
            }
        }
    }
}